/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CustomFormControl from '../../../shared/atoms/CustomFormControl';
import UserGroupSelect from '../../../shared/molecules/UserGroupSelect';
import CustomSelect from '../../../shared/atoms/CustomSelect';

const AddBatchDeviceForm = ({
  handleBlur,
  handleChange,
  values,
  errors,
  touched,
  resetForm,
  initialValues,
  setFieldValue,
  setFieldTouched,
  locations,
  isFetchingLocations,
  isValid,
  setIsValid,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setIsValid(isValid);
  }, [isValid, setIsValid]);

  return (
    <Form style={{ textAlign: 'left' }}>
      <CustomSelect
        value={values.locationName}
        id="locationName"
        label={t('management_menu.display_management.create.location')}
        onChange={handleChange}
        onBlur={handleBlur}
        options={locations.map(l => ({ label: l.label, value: l.label }))}
        touched={touched}
        errors={errors}
        isLoading={isFetchingLocations}
        required
      />

      <CustomFormControl
        type="text"
        id="timeout"
        name="timeout"
        info={t('management_menu.asset_wizard.sensor.timeout_tooltip')}
        label={t('modal.add_batch_device.timeout')}
        value={values.timeout}
        onBlur={handleBlur}
        onChange={handleChange}
        touched={touched}
        errors={errors}
        required
      />

      <UserGroupSelect
        resetForm={resetForm}
        initialValues={initialValues}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        handleBlur={handleBlur}
        touched={touched}
        errors={errors}
        value={values.user_group}
      />
    </Form>
  );
};

AddBatchDeviceForm.displayName = 'AddBatchDeviceForm';
export default AddBatchDeviceForm;

AddBatchDeviceForm.propTypes = {
  errors: PropTypes.shape({
    locationName: PropTypes.any,
    timeout: PropTypes.any,
    user_group: PropTypes.any,
  }).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  initialValues: PropTypes.any,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  touched: PropTypes.shape({
    locationName: PropTypes.any,
    timeout: PropTypes.any,
    user_group: PropTypes.any,
  }).isRequired,
  values: PropTypes.shape({
    locationName: PropTypes.string,
    timeout: PropTypes.string,
    user_group: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  locations: PropTypes.arrayOf(PropTypes.any),
  isFetchingLocations: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  setIsValid: PropTypes.func.isRequired,
};
